





















import Vue from 'vue';
import LoginForm from '@/views/LoginPage/LoginForm.vue';
import LoginLogo from '@/views/LoginPage/LoginLogo.vue';
import LoginNotification from '@/views/LoginPage/LoginNotification.vue';
import AppFooter from '@/components/layout/AppFooter.vue';

export default Vue.extend({
  name: 'Login',
  components: {
    LoginNotification,
    LoginForm,
    LoginLogo,
    AppFooter,
  },
});
